import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import moment from 'moment-timezone';
import './WorldClockComponent.css';

const WorldClockComponent = () => {
  const defaultCountry = "America/New_York"; // Default country to be selected
  const [selectedCountry, setSelectedCountry] = useState({
    label: defaultCountry.replace('_', ' '),
    value: defaultCountry
  });
  const [time, setTime] = useState('');

  const countryOptions = moment.tz.names().map((timezone) => ({
    label: timezone.replace('_', ' '),
    value: timezone,
  }));

  useEffect(() => {
    const updateTime = () => {
      const localTime = moment().tz(selectedCountry.value).format('MMMM Do YYYY, h:mm:ss A');
      setTime(localTime);
    };
    updateTime();
    const intervalId = setInterval(updateTime, 1000);

    return () => clearInterval(intervalId);
  }, [selectedCountry]);

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  return (
    <div className="world-clock-container">
      <h2>World Clock</h2>
      <Select
        className="country-select"
        options={countryOptions}
        onChange={handleCountryChange}
        value={selectedCountry}
        placeholder="Select a country"
      />
      {selectedCountry && (
        <div className="time-display">
          <h3>Time in {selectedCountry.label}</h3>
          <div className="clock">
            <div className="time">{time.split(', ')[1]}</div>
            <div className="date">{time.split(', ')[0]}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorldClockComponent;
